import R from "../../R";

export function CrossIcon(props: React.SVGProps<SVGSVGElement>) {
  const width = props.width || 18;
  const height = props.height || 18;

  const color = R.colors.vividBlue;
  return (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.40015 5.4L12.6001 12.6M5.40015 12.6L12.6001 5.4"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
